import React from 'react'
import ProTeacherSkillBox from '../../features/proteacher/ProTeacherSkillBox'

const ProTeacherSkillBoxPage = () => {
    return (
        <ProTeacherSkillBox />
    )
}

export default ProTeacherSkillBoxPage
